import useTranslations from '../../../hooks/useTranslations'
import ANTDModal from '../../../shared/antd/ANTDModal'
import { include } from '../../../utils/javascript'

function PreviewImage({ imagePreview, handleCancel }) {
  const { t } = useTranslations()

  const imageType =
    imagePreview?.type || /\.\w+$/.exec(imagePreview?.image)?.[0]
  const fileName = imagePreview?.fileName || ''
  const isDoc =
    fileName.toLowerCase().endsWith('.doc') ||
    fileName.toLowerCase().endsWith('.docx')
  const isPdf = include(imageType, 'pdf')

  const iframeSrc =
    isDoc && imagePreview?.image
      ? `https://docs.google.com/gview?url=${encodeURIComponent(
          imagePreview.image,
        )}&embedded=true`
      : imagePreview?.image

  return (
    <ANTDModal
      open={imagePreview?.visible}
      footer={null}
      onCancel={handleCancel}
      title={t('job_Preview')}
      destroyOnClose
      width={isPdf || isDoc ? 800 : 500}
    >
      {['mp4', 'mov', 'avi', 'wmv', 'avchd', 'webm', 'flv'].some(type =>
        include(imageType, type),
      ) ? (
        <video width="470" controls autoplay>
          <source src={imagePreview?.image} type="video/mp4" />
        </video>
      ) : isPdf || isDoc ? (
        <iframe
          src={iframeSrc}
          title={t('job_Preview')}
          height="750px"
          width="100%"
        />
      ) : (
        <img
          alt={t('job_Preview')}
          src={imagePreview?.image}
          className="w-100 border-black-1"
        />
      )}
    </ANTDModal>
  )
}

export default PreviewImage
